export default {
  beCool: {
    id: '404_page_be_cool',
    defaultMessage: 'Stay cool, everything’s going to be ok.',
  },
  cta: {
    id: 'error_page_cta',
    defaultMessage: 'Click here to shop',
  },
  relaxed: {
    id: '404_page_you_are_totally_relaxed',
    defaultMessage: 'See, you’re totally relaxed now.',
  },
  subtitle: {
    id: '404_page_subtitle',
    defaultMessage: 'This link has not yet been refurbished.',
  },
  text: {
    id: 'error_page_text',
    defaultMessage:
      'So why not shop around and check out some of our sweet deals?',
  },
  title: {
    id: '404_page_title',
    defaultMessage: '"Gottferdam"',
  },
}
